import { EAuthUrls } from 'data/urls/auth.url';
import { EPropertyMangerUrl } from 'data/urls/propertyManager.url';
import { TSetPasswordFormDB, TSetPasswordFormUI } from 'data/types/auth.types';
import { setNewPasswordConverter } from 'data/converters/auth.converters';
import { BaseQuery, QueryReturnValue } from '../store';

export const setNewPasswordService = async (baseQuery: BaseQuery, arg: TSetPasswordFormUI) => {
  const data = (await baseQuery({
    url: `${EPropertyMangerUrl.PROPERTY_MANAGER}/${EAuthUrls.AUTH}/${EAuthUrls.TEMPORARY_PASSWORD}`,
    method: 'PATCH',
    body: setNewPasswordConverter.toDb(arg),
  })) as QueryReturnValue<TSetPasswordFormDB>;
  return { data };
};
